import React from 'react';

/**
 * WatchlistViewTabs - Toggle between "My Tickers" and "Received" views
 * Consistent with Dashboard and Polls tabs
 */
const WatchlistViewTabs = ({ 
  watchlistView, 
  setWatchlistView, 
  myWatchlistsCount, 
  receivedCount
}) => {
  return (
    <div className="flex items-center bg-black/20 rounded-lg p-1">
      <button
        onClick={() => setWatchlistView('my')}
        data-testid="my-tickers-tab"
        className={`flex-1 sm:flex-none px-3 py-1 text-xs sm:text-sm font-medium rounded transition-all duration-200 ${
          watchlistView === 'my' 
            ? 'bg-white text-slate-800 shadow-sm' 
            : 'text-white/70 hover:text-white'
        }`}
      >
        My Tickers
        {myWatchlistsCount > 0 && (
          <span className={`ml-1.5 ${watchlistView === 'my' ? 'text-slate-500' : 'text-white/50'}`}>
            ({myWatchlistsCount})
          </span>
        )}
      </button>
      <button
        onClick={() => setWatchlistView('received')}
        data-testid="received-collections-tab"
        className={`flex-1 sm:flex-none px-3 py-1 text-xs sm:text-sm font-medium rounded transition-all duration-200 ${
          watchlistView === 'received' 
            ? 'bg-white text-slate-800 shadow-sm' 
            : 'text-white/70 hover:text-white'
        }`}
      >
        Received
        {receivedCount > 0 && (
          <span className={`ml-1.5 ${watchlistView === 'received' ? 'text-slate-500' : 'text-white/50'}`}>
            ({receivedCount})
          </span>
        )}
      </button>
    </div>
  );
};

export default WatchlistViewTabs;
